jQuery(document).ready(function($){


	/****** SCROLL TO #HREF *******/

		var names = $('body').find('a[name]');
		names.each(function(index){
			$(this).attr('id',$(this).attr('name'));
		});

		function scrollable(element) {
			var link = element[0].href;
			link = link.replace(element[0].hash,'');
			link = link.replace('#','');
			if (link.charAt(link.length -1) != '/') {
				link = link+'/';
			};


			var baseuri = window.location.protocol+'//'+window.location.hostname+window.location.pathname;


			if (link != baseuri) return false;
			if (element.hasClass('ui-tabs-anchor')) return false;
			if (element.hasClass('vc-carousel-control')) return false;
			if (element.closest('div').hasClass('opinie-pagination')) return false;
			if (element.closest('.tr-prevnext').length) return false;
			// if (element.closest('nav.main-navigation').length ) return false;
			if (element.closest('h3').hasClass('wpb_accordion_header') ) return false;

			return true;
		}


		function scrollToCallback(e){
			if (scrollable($(this)))
			{
				var offset =  95;
				var item = $(this.hash);
				var h = 0;
				var w = 0;
				if (item.length > 0) {
					h = item.offset().top;
					h -= offset;
					w = item.offset().left;
				};

				$('html,body').scrollTo(w,h,{animation:{duration:900, easing:'swing'}});
				e.preventDefault();
			}
		}

		$('a[href*="#"]').on('click',scrollToCallback);

	$('.percengate > span').each(function () {
	    $(this).prop('Counter',0).animate({
	        Counter: 80
	    }, {
	        duration: 10000,
	        easing: 'linear',
	        step: function (now) {
	            $(this).text(Math.ceil(now));
	        }
	    });
	});

	// /****** Auto Slideshow *******/
	// function changeSlideshowStatus() {
	// 	if ($('#fancybox-pause').hasClass('active')) {
	// 		$('#fancybox-pause').removeClass('active');
	// 		$.session.set("autoSlideshow", false );
	// 	} else {
	// 		$('#fancybox-pause').addClass('active');
	// 		$.session.set("autoSlideshow", true );
	// 	}
	// }
	//
	// var slideshowInterval = false;
	// function autoSlideshow() {
	// 	if ($('#fancybox-pause').length == 0)
	// 		$('#fancybox-close').before('<a id="fancybox-pause"></a>');
	//
	// 	$('#fancybox-pause').show();
	//
	// 	$('#fancybox-pause').on('click',function(){
	// 		changeSlideshowStatus();
	// 		// autoSlideshow();
	// 	});
	//
	// 	if ($.session.get('autoSlideshow') == 'true' || !$.session.get('autoSlideshow')) {
	//
	// 		$.session.set("autoSlideshow", true );
	// 		$('#fancybox-pause').addClass('active');
	//
	// 	} else {
	// 		$('#fancybox-pause').removeClass('active');
	// 	}
	//
	// 	if (slideshowInterval == false) {
	// 		slideshowInterval = true;
	// 		setInterval(function(){
	//
	// 			if ($('#fancybox-pause').hasClass('active'))
	// 				$('#fancybox-right').trigger('click');
	// 		}, 6000);
	// 	}
	//
	// }
	//
	// $('.gallery-realization-container .gallery-item').on('click',autoSlideshow);


	/****** FIXED NAVBAR *******/

	function addHeaderClass() {

		var window_top = $(window).scrollTop();

		if ($('.home-banner').outerHeight()) {
			var offset = $('.home-banner').outerHeight() - $('.site-header').outerHeight();
			var headerOffset = $('.site-header').outerHeight() + $('.home-banner').outerHeight();

			if (window_top > offset) {
				$('.site-header').addClass('sticky');
				if(window_top > headerOffset) {
					$('.site-header').addClass('transparent');
				}
			} else {
				$('.site-header').removeClass('transparent');
				$('.site-header').removeClass('sticky');
			}
		}
	}

	/****** HOME BANNER FADE *******/

	// function homeBackgroundFade() {
	// 	var banner = $('.home-banner');
	// 		bannerHeight = banner.outerHeight();
	//     	scrollPercent = (bannerHeight - $(window).scrollTop()) / bannerHeight;
	//     	blur = $(window).scrollTop() / bannerHeight * 5;
	//     if(scrollPercent >= 0){
	//         banner.css('opacity', scrollPercent);
	//         if (blur < 20) {
	// 	        banner.css({
	//                 "-webkit-filter": "blur("+blur+"px)",
	//                 "filter": "blur("+blur+"px)"
	//             });
	//         }
	//     }
	// }

	/****** MOBILE MENU *******/

	$('#toggle').on('click',function(){
		if ($(this).hasClass('open')) {
			$('.navigation-container').slideUp(300);
			$(this).removeClass('open');
		} else {
			$('.navigation-container')
				.css('display','flex')
				.hide()
				.slideDown(300);
			$(this).addClass('open');
		}
	});

	// na resize usuń ręcznie dodane style dla .navigation-container
	$(window).on('resize',function(){
		if ($(window).width() > 1024) {
			$('.navigation-container').removeAttr('style');
			$('#toggle').removeClass('open');
		}
	}
	);


	// $('.main-navigation div>ul>li').on('click',function(){
	// 	$(this).find('.sub-menu').slideToggle();
	// 	if ($(this).hasClass('active')) {
	// 		$(this).removeClass('active');
	// 	} else {
	// 		$(this).addClass('active');
	// 	}
	// });

	/****** SCROLL EVENT *******/

	$(window).scroll(function(){
	//     homeBackgroundFade();
	    addHeaderClass();
	//     hiddenHomeDescription();
    })

	// $( window ).load(function() {
	// 	$('body').fadeIn(200);
	// });

	/* === Gallery Swiper – inicjuj tylko, jeśli jest element === */

	$('.carousel').slick({
		autoplay: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		speed: 2000,
		autoplaySpeed: 2000,
		pauseOnHover: false,
		pauseOnFocus: false,
		dots: false,
		arrows: false,
		draggable: false,
	});


	const $slider = $('.hero-carousel')

	const options = {
		autoplay: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		speed: 4000,
		autoplaySpeed: 4000,
		pauseOnHover: false,
		pauseOnFocus: false,
		dots: false,
		arrows: false,
		draggable: false,
		variableWidth: true,
		touchMove: false,
	};

	// $slider.on('beforeChange', function(e, slick, current, next){
	// 	if (current === slick.slideCount - 1 && next === 0) {
	// 		$slider.slick('unslick');
	// 		// $slider.html(originalHTML);
	// 		$slider.slick(options);
	// 	}
	// });

	$slider.slick(options);
});
//
// import Glide from '@glidejs/glide'
// 	new Glide('.glide').mount()



